import { inject, injectable } from 'inversify'
import type { FilterStrategyInterface } from '@/services/tables/filters/strategies/types/filterStrategyInterface'
import type { FilterField } from '@/services/tables/filters/fields/filterField'
import type { FilterOperationValue } from '@/services/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { BaseFilterStrategy } from '@/services/tables/filters/strategies/baseFilterStrategy'
import type { ParsedFilterType } from '@/services/tables/types'
import type { FilterStrategyGetPopulateDataResult } from '@/services/tables/filters/strategies/types/filterStrategyGetPopulateDataResult'
import type { SelectOption } from '@/services/forms/types'

@injectable()
export class ArrayFilterStrategy implements FilterStrategyInterface {
  constructor(@inject(SERVICE_TYPES.BaseFilterStrategy) protected readonly baseFilterStrategy: BaseFilterStrategy) {}

  public toQueryPart(filter: FilterField): Partial<FilterOperationValue> {
    const value = filter.getApiValue()
    const operation = filter.operation
    const relationField = filter.getRelationField()

    return this.baseFilterStrategy.fieldDataToQueryPart({ operation, relationField, value })
  }

  public getPopulateData(
    filter: FilterField,
    payload: ParsedFilterType[],
    selectedItems?: SelectOption[],
  ): FilterStrategyGetPopulateDataResult {
    return this.baseFilterStrategy.getPopulateData(filter, payload, selectedItems)
  }

  public checkFilterValue(filter: FilterField, valueToCheck: unknown): boolean {
    return this.baseFilterStrategy.checkFilterValue(filter, valueToCheck)
  }
}
